import axios from 'axios';
import axiosInstance from 'Services/APIService';


export interface UserRole {
  role_id: string;
  label: string;
}

export interface GoogleAuthUser {
  email: string;
  name: string;
  role: UserRole[];
}

export interface GoogleAuthResponse {
  user?: GoogleAuthUser;
  avatar?: string;
  token?: string;
  groups?: string[];
  userId?: string;
  profile_complete?: boolean;
  missing_fields?: string[];
  message?: string;
  error?: string;
}

// Forgot Password - Send OTP
export const sendPasswordResetOTP = async (email: string) => {
  try {
    const response = await axiosInstance.post('/ForgotPassword/SendOTP', { email });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { error: 'Failed to send OTP' };
  }
};

// Forgot Password - Reset Password
export const resetPasswordWithOTP = async (
  email: string,
  otp: string,
  newPassword: string,
  confirmPassword: string
) => {
  try {
    const response = await axiosInstance.post('/ForgotPassword/ResetPassword', {
      email,
      otp,
      newPassword,
      confirmPassword,
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { error: 'Failed to reset password' };
  }
};

// Google OAuth - Continue with Google
export const continueWithGoogle = async (idToken: string, profileData?: any): Promise<GoogleAuthResponse> => {
  try {
    const payload: any = {
      id_token: idToken,
      profile_data: profileData || {}
    };
    
    if (profileData) {
      payload.profile_data = {
        first_name: profileData.first_name || '',
        last_name: profileData.last_name || '',
        phone: profileData.phone || '',
        surburb: profileData.surburb || '',
        state: profileData.state || '',
        country_res: profileData.country_res || '',
        postcode: profileData.postcode || '',
        groups: Array.isArray(profileData.groups) ? profileData.groups : (profileData.groups ? [profileData.groups] : []),
        avatar: profileData.avatar || ''
      };
    }
    
    const response = await axiosInstance.post('auth/google/continue', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      timeout: 30000
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }
    
    if (error.code === 'ECONNABORTED') {
      throw { error: 'Request timeout. The server took too long to respond. Please try again.' };
    } else if (error.message === 'Network Error') {
      throw { error: 'Network error. Please check your connection and try again.' };
    } else if (!error.response) {
      throw { error: 'Connection failed. Please check your internet connection and try again.' };
    }
    
    throw { error: error.message || 'Google authentication failed. Please try again.' };
  }
};

export default axiosInstance;
